import * as React from 'react';
import { RampWithNameTransform, TopModelContextProvider } from '@goldwasserexchange/react-topmodel';
import ouiBase from '@goldwasserexchange/oui';
import ouiStyle from '@goldwasserexchange/oui-style';
import { UseGetFnProps } from '../shared';
import { SearchKeysProps } from '../shared/components/list/context/searchKeys/context';

export function RadioListInputStructure<M>(
  props: React.PropsWithChildren<
  {
    fieldPath: string,
    topModelsOverride?: M,
    elementLines?: ouiStyle.InStyle['lines'],
    dependenciesFieldPaths?: string[],
  } & Partial<SearchKeysProps> & Partial<UseGetFnProps> & ouiBase.List.ListProps & ouiBase.List.ListDataFilterAndSortProviderProps
  >,
) {
  const {
    fieldPath,
    dependenciesFieldPaths,
    topModelsOverride: defaultTopModels,
    list,
    length,
    children,
    elementLines,
    useFilterFn,
    useSortFn,
    useGetFn,
    searchKeys,
  } = props;
  return (
    <TopModelContextProvider topModels={defaultTopModels}>
      {children}
      <RampWithNameTransform<
      {
        fieldPath: string,
        elementLines?: ouiStyle.InStyle['lines'],
        type: Extract<ouiBase.Input.InputTypes, 'radio'>,
        dependenciesFieldPaths?: string[],
      } & Partial<SearchKeysProps> & Partial<UseGetFnProps> & ouiBase.List.ListProps & ouiBase.List.ListDataFilterAndSortProviderProps
      >
        rampName="InputBase"
        type="radio"
        fieldPath={fieldPath}
        dependenciesFieldPaths={dependenciesFieldPaths}
        list={list}
        length={length}
        elementLines={elementLines}
        useFilterFn={useFilterFn}
        useSortFn={useSortFn}
        useGetFn={useGetFn}
        searchKeys={searchKeys}
      />
    </TopModelContextProvider>
  );
}
